import { Trophy, MapPin, Sparkles } from "lucide-react";
import { useStore } from "@/lib/store";
import { translations } from "@/lib/i18n";

export default function About() {
  const { lang } = useStore();
  const t = translations[lang];

  const pillars = [
    { Icon: Trophy, title: t.about_pillar_1_title, body: t.about_pillar_1_body },
    { Icon: MapPin, title: t.about_pillar_2_title, body: t.about_pillar_2_body },
    { Icon: Sparkles, title: t.about_pillar_3_title, body: t.about_pillar_3_body },
  ];

  return (
    <div className="max-w-6xl mx-auto px-6 py-14" data-testid="about-page">
      <p
        className="text-xs tracking-[0.5em] text-yellow-400/80 mb-3"
        style={{ fontFamily: '"JetBrains Mono", monospace' }}
      >
        {t.about_eyebrow}
      </p>
      <h1
        className="text-5xl sm:text-6xl font-black mb-8"
        style={{
          fontFamily: '"Bebas Neue", system-ui',
          background: "linear-gradient(180deg, #fff, #F4D77A)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
        }}
      >
        {t.about_title}
      </h1>

      <div className="grid md:grid-cols-5 gap-10 items-center">
        <div className="md:col-span-3 space-y-5 text-white/75 leading-relaxed">
          <p>{t.about_body_1}</p>
          <p>{t.about_body_2}</p>
        </div>
        <div className="md:col-span-2">
          <img
            src="/logos/braf_zak_logo_main.jpeg"
            alt="Braf_Zak"
            className="w-full aspect-square object-cover rounded-3xl border border-yellow-500/20"
            style={{ boxShadow: "0 30px 60px -20px rgba(212,175,55,0.35)" }}
          />
        </div>
      </div>

      <div className="grid md:grid-cols-3 gap-5 mt-16">
        {pillars.map(({ Icon, title, body }, i) => (
          <div
            key={title}
            data-testid={`about-pillar-${i}`}
            className="p-7 rounded-2xl border border-yellow-500/20 bg-white/[0.02]"
            style={{ animation: `fadeUp 0.7s ease ${0.1 * i}s both` }}
          >
            <Icon className="w-7 h-7 text-yellow-400 mb-4" strokeWidth={2.2} />
            <h3
              className="text-2xl font-black text-yellow-100 mb-2"
              style={{ fontFamily: '"Bebas Neue", system-ui' }}
            >
              {title}
            </h3>
            <p className="text-white/65 text-sm leading-relaxed">{body}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
